/* eslint-disable react/button-has-type */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import 'mobx-react/batchingForReactDom';
import { Toast, Modal } from 'antd-mobile';
import TIM from 'tim-js-sdk';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import LiveComponent from '../../components/live/live';
import tim from '../../public/js/tim';
import styles from './styles.module.less';
import ThumbsUpAni from '../../utils/canvas';
import tools, { isIOS } from '../../utils/tools';
import {
  getImAppId, getImOpenId, getImUserSig, verifyGetLive, giveFabulous,
} from '../../service/chat-service';
import config from '../../config/app-config';
import TencentVideoPLay from '../live/tencentVideoPLay';
import WXShare from '../../components/WxShare/index';

import heart from '../../public/images/heart.png';
import activeHeart from '../../public/images/Heart-active.png';
import input from '../../public/images/live-input.png';
import imgSignal from '../../public/images/signal.png';
import linkProduct from '../../public/images/link_product.png';
import livePro from '../../public/images/live-pro.png';
import dianDianDian from '../../public/images/diandiandian.png';
import liveClose from '../../public/images/liveClose.png';
import liveErweim from './img/liveErweim.png'; // 二维码
import livefenx from './img/livefenx.png'; // 分享
import liveger from './img/liveger.png'; // 个人
import livekefu from './img/livekefu.png'; // 客服
import liveshop from './img/liveshop.png'; // 店铺
import livetext from './img/livetext.png'; // 文档
import ti from './img/TI.png'; // 提问
import LiveList from './index';

// C82BB6FE5742476799A0AA75273D0829

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  emptyCurrentMessageList: PropTypes.func,
  pushCurrentMessageList: PropTypes.func,
  setEndLive: PropTypes.func,
  setConversationID: PropTypes.func,
  setLivePerson: PropTypes.func,
  currentMessageList: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.number,
    }),
  ),
  endLive: PropTypes.bool,
  livePerson: PropTypes.number,
};
const defaultProps = {
  emptyCurrentMessageList: () => {},
  pushCurrentMessageList: () => {},
  setEndLive: () => {},
  setConversationID: () => {},
  setLivePerson: () => {},
  currentMessageList: [],
  endLive: false,
  livePerson: 0,
};

@inject(({ LiveMessageList }) => ({
  currentMessageList: LiveMessageList.currentMessageList,
  preScrollHeight: LiveMessageList.preScrollHeight,
  endLive: LiveMessageList.endLive,
  livePerson: LiveMessageList.livePerson,

  getMessageLists: LiveMessageList.getMessageLists,
  pushCurrentMessageList: LiveMessageList.pushCurrentMessageList,
  emptyCurrentMessageList: LiveMessageList.emptyCurrentMessageList,
  setConversationID: LiveMessageList.setConversationID,
  setEndLive: LiveMessageList.setEndLive,
  setLivePerson: LiveMessageList.setLivePerson,
}))
@observer
class LiveRegistration extends Component {
  constructor(props) {
    super(props);

    const windowHref = window.location.search;

    this.state = {
      isHeartShow: false,
      streamName: queryString.parse(windowHref).streamName || '',
      fileId: '',
      groupId: '',
      liveInfo: {},
      shareUserId: queryString.parse(windowHref).shareUserId,
      liveId: queryString.parse(windowHref).liveId || '0',
      // isShowScrollButtomTips: false,
      inputFocus: false,
      value: '',
      // liveProduct: false,
      liveProductStr: '',
      isRecord: queryString.parse(windowHref).isRecord || 0,
      welcomeFlag: false,
      flag: true, // 点赞一次
      mobile: queryString.parse(windowHref).mobile || '',
      // fromNick: '',
      // animating: false,
      moreShow: false, // 更多的展示隐藏
      pools: [], // 主讲人
      visvilt2: false,
      visvilt2Url: '',
      tel: '', // 打电话
      files: [], // 文档
      file: false,
      tjSpData: [], // 推荐商品
      lbSpData: [], // 列表商品
      spData: [], // 秒杀商品
      modeKey: null, // 弹出框
      put: '看全部',
      tjspObj: null, // 选中的商品
      tjIndex: '', // 下标
      videoHeight: 240, // 视频高度
    };

    // 初始化监听器
    this.initListener();

    document.title = '直播';
  }

  componentDidMount() {
    const { emptyCurrentMessageList } = this.props;
    const { isSDKReady } = this.state;
    this.getLiveOpenId();
    // this.getImUserSig(new Date().getTime(), `测试${new Date().getTime()}`)
    if (window.location.pathname.indexOf('liveRegistration') > -1) {
      if (isSDKReady) {
        tim.logout();
      }
      emptyCurrentMessageList();
    }
  }

  /**
   * IM Sdk是否处于ready状态
   * @param name
   * @returns {Promise<void>}
   */
  onReadyStateUpdate({ name }) {
    const isSDKReady = name === TIM.EVENT.SDK_READY;
    this.setState({ isSDKReady: name === TIM.EVENT.SDK_READY });
    if (isSDKReady) {
      // this.setState({ animating: false });
      tim.getMyProfile().then((res) => {
        // 获取本人的昵称。用于发送消息
        this.setState({ myNick: res.data.nick });
      });
    }
  }

  /**
   * 监听是否存在新消息
   * @param event
   */
  onReceiveMessage(event) {
    const { pushCurrentMessageList } = this.props;

    // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
    // event.name - TIM.EVENT.MESSAGE_RECEIVED
    // event.data - 存储 Message 对象的数组 - [Message]
    const { length } = event.data;

    let message;
    let payload = false;
    for (let i = 0; i < length; i += 1) {
      // Message 实例的详细数据结构请参考 Message
      // 其中 type 和 payload 属性需要重点关注
      // 从v2.6.0起，AVChatRoom 内的群聊消息，进群退群等群提示消息，增加了 nick（昵称） 和 avatar（头像URL） 属性，便于接入侧做体验更好的展示
      // 前提您需要先调用 updateMyProfile 设置自己的 nick（昵称） 和 avatar（头像URL），请参考 updateMyProfile 接口的说明
      message = event.data[i];
      switch (message.type) {
        case TIM.TYPES.MSG_TEXT:
          // 收到了文本消息
          pushCurrentMessageList(message);
          this.scrollToBottom();
          break;
        case TIM.TYPES.MSG_CUSTOM:
          // 收到了自定义消息
          pushCurrentMessageList(message);
          this.scrollToBottom();
          break;
        case TIM.TYPES.MSG_GRP_TIP:
          // 收到了群提示消息，如成员进群、群成员退群
          this.handleGroupTip(message);
          break;
        case TIM.TYPES.MSG_GRP_SYS_NOTICE:
          pushCurrentMessageList(message);
          payload = false;
          if (message.payload.userDefinedField) {
            payload = JSON.parse(message.payload.userDefinedField);
          }
          if (!!payload && payload.MsgType === 'spData') {
            this.setState({ liveProductStr: payload.MsgContent });
          }
          // 收到了群系统通知，通过 REST API 在群组中发送的系统通知请参考 在群组中发送系统通知 API
          break;
        default:
          break;
      }
    }

    // if (messageList[0].conversationType !== "@TIM#SYSTEM" && !!preScrollHeight)
    //   this.setState({ isShowScrollButtomTips: true });
  }

  static onError({ data }) {
    if (data.message !== 'Network Error') {
      // Toast.show(data.message);
    }
  }

  /**
   * 页面滚动至底部
   */
  scrollToBottom = () => {
    const { scrollHeight } = this.messagesEnd; // 里面div的实际高度
    this.messagesEnd.scrollTop = scrollHeight;
  }

  /**
   * 初始化SDK，所有SDK均在EVENT.SDK_READY ready之后方可调用
   */
  initListener = () => {
    // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
    tim.on(TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this);
    // 收到新消息
    tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage, this);
    // SDK内部出错
    tim.on(TIM.EVENT.ERROR, LiveRegistration.onError);
  }

  /**
   * 主动授权
   * @param appId
   * @returns {string}
   */
  toWxth = (appId) => `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
    window.location.href,
  )}&response_type=code&scope=snsapi_userinfo&source_type=wx&state=3#wechat_redirect`

  /**
   * 微信授权
   * @returns {Promise<void>}
   */
  getLiveOpenId = async () => {
    const windowHref = window.location.search;
    const WXCode = queryString.parse(windowHref).code;
    // const { isRecord } = this.state;

    if (!WXCode) {
      localStorage.clear();
      // 动态获取 微信 appId
      try {
        const { code, data, message } = await getImAppId();
        if (process.env.REACT_APP_API_ENV === 'local') {
          // 本地测试时不走微信验证
          this.getImUserSig('oQd0LwJcSPgP7eYwSy38bUdb793A', 'nickname');
        } else if (code === 10000) {
          window.location.href = this.toWxth(data);
        } else {
          Toast.show(message || '获取微信 appId 失败');
        }
      } catch (e) {
        Toast.show(e || '获取微信 appId 失败');
      }
    } else if (!localStorage.getItem('nickname')) {
      try {
        const { code, data } = await getImOpenId(WXCode, 1);
        if (code === 10000) {
          localStorage.setItem('openId', data.openid);
          localStorage.setItem('nickname', data.nickname);
          // if (!Number(isRecord))
          this.getImUserSig(data.openid, data.nickname);
        }
      } catch (e) {
        Toast.show(e);
      }
    } else {
      this.getImUserSig(localStorage.getItem('openId'), localStorage.getItem('nickname'));
    }
  }

  /**
   * 获取IM签名
   * @param openId
   * @param name   昵称
   * @returns {Promise<void>}
   */
  getImUserSig = async (openId, name) => {
    const { isRecord } = this.state;
    console.log(isRecord);
    try {
      const { data, code, message } = await getImUserSig(openId, name);
      if (code === 10000) {
        this.imLogin(openId, data);
        this.verifyGetLive(openId, data);
        // this.setState({ animating: false });
      } else {
        Toast.show(message);
        // this.setState({ animating: false });
      }
    } catch (e) {
      // this.setState({ animating: false });
    }
  }

  /**
   * 进入直播间、录播间
   * @param openId
   * @param data
   * @param name
   */
  verifyGetLive = (openId) => {
    const { setEndLive, setConversationID, setLivePerson } = this.props;
    const {
      // streamName,
      mobile,
      shareUserId,
      liveId,
    } = this.state;
    verifyGetLive(liveId, openId, mobile, shareUserId)
      .then(({ data, code, message }) => {
        if (code === 10000) {
          this.liveDetail = { ...data.liveInfo, liveId: data.liveId };
          setEndLive(data.liveInfo.streamState === 'active');
          // 设置群聊ID
          setConversationID(data.liveInfo.groupId);
          setLivePerson(data.groupNum);
          this.setState({
            // animating: false,
            groupId: data.liveInfo.groupId,
            fileId: data.liveInfo.fileId,
            liveInfo: data.liveInfo,
            enterRoom: true,
            pools: data.pools, // 讲师
            files: data.files, // 文档
            tjSpData: data.tjSpData, // 推荐商品
            lbSpData: data.lbSpData, // 列表商品
            spData: data.spData, // 秒杀商品
          });
          this.joinMemberGroup(data.liveInfo.groupId);
        } else {
          Toast.show(message);
          // this.setState({ enterRoom: false });
          setEndLive(false);
        }
      })
      .catch(() => {
        this.setState({ enterRoom: false });
        setEndLive(false);
      });
  }

  /**
   * IM SDK登录
   */
  imLogin = (openId, data) => {
    tim
      .login({
        userID: openId || '',
        userSig: data,
      })
      .then(() => {
        // console.log(this.state.groupId);
        // console.log(res);
      });
  }

  /**
   * AVCHATROOM 加入群聊
   * @param groupID
   */
  joinMemberGroup = (groupID) => {
    const promise = tim.joinGroup({ groupID });
    promise
      .then((imResponse) => {
        switch (imResponse.data.status) {
          case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意
            break;
          case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
            break;
          case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
            break;
          default:
            break;
        }
      })
      .catch(() => {
        // console.warn('joinGroup error:', imError); // 申请加群失败的相关信息
      });
  }

  /**
   * 获取消息列表
   * @returns {*}
   */
  renderMessageList = () => {
    const { currentMessageList } = this.props;
    const { put } = this.state;
    if (!currentMessageList.length) return <div />;
    if (put === '看提问') {
      return currentMessageList.map((item) => {
        if (item.payload.extension === '?') {
          return <div key={item.ID}>{item.conversationType === '@TIM#SYSTEM' ? this.renderWelcome(item) : this.renderChatList(item)}</div>;
        }
        return true;
      });
    }
    return currentMessageList.map((item) => (
      <div key={item.ID}>{item.conversationType === '@TIM#SYSTEM' ? this.renderWelcome(item) : this.renderChatList(item)}</div>
    ));
  }

  /**
   * 渲染欢迎语
   * @param item
   * @returns {*}
   */
  renderWelcome = (item) => {
    const { setEndLive, setLivePerson } = this.props;
    if (!item.payload.userDefinedField) return;

    const payload = JSON.parse(item.payload.userDefinedField);

    if (payload.MsgType === 'online') {
      setLivePerson(payload.MsgContent);
    }
    if (payload.MsgType === 'end') {
      setEndLive(false);
    }
  }

  /**
   * 关联商品价格回显
   * @returns {string|null}
   */
  renderPrice = (data) => {
    const isOpenAccount = data.templateType === 4;

    if (isOpenAccount) {
      // 开户模式
      return null;
    }
    // eslint-disable-next-line default-case
    switch (data.priceType) {
      case 2: {
        // 一口价
        return (
          <div>
            <span>
              <span style={{ fontSize: '12px' }}>￥</span>
              {tools.getMoney(data.price)}
            </span>
            {/**
             <span className={styles.discount}>
              ￥
              {tools.getMoney(data.originalPrice)}
            </span>
            */}
          </div>
        );
      }
      case 4: {
        // 组合价
        return (
          <div>
            <span>
              <span style={{ fontSize: '12px' }}>￥</span>
              {tools.getMoney(data.specPrice)}
            </span>
            {
              /**
               * <span className={styles.discount}>
              ￥
              {tools.getMoney(data.specOriginalPrice)}
            </span>
               *
               */
            }
          </div>
        );
      }
      default:
        return '';
    }
  }

  renderLiveProduct = () => {
    const { liveProductStr, spData } = this.state;
    if (spData.length === 0) return <div />;
    // const payload = JSON.parse(liveProductStr);
    const obj = spData[0];
    console.log(liveProductStr);
    return (
      <div className={styles.list} onClick={this.goProductDetail.bind(null, obj)} role="button" tabIndex={0}>
        <div className={styles.jieshao}>
          <img src={obj.imgUrl || linkProduct} alt="" />
          <div className={styles.price} style={{ width: '100%' }}>{this.renderPrice(obj)}</div>
        </div>
      </div>
    );
  }

  /**
   * 渲染聊天内容
   * @param item
   * @returns {*}
   */
  renderChatList = (item) => {
    const { myNick } = this.state;
    return (
      <div className={styles.messageItem}>
        <div className={styles.message} style={{ display: 'flex' }}>
          {item.payload.extension === '?' && <img src={ti} alt="" style={{ width: 16, height: 16 }} />}
          <span className={styles.nickName}>
            {item.flow === 'in' ? item.nick : myNick}
            :
          </span>
          {item.payload.extension === '?' ? item.payload.data : item.payload.text}
        </div>
      </div>
    );
  }

  /**
   * 设置发送消息
   * @param e
   */
  handleMsg = (val) => {
    const { pushCurrentMessageList } = this.props;
    const { value, isSDKReady, groupId } = this.state;
    let message = null;
    if (!value) {
      Toast.info('不能发送空白消息 !!!', 1);
    } else {
      if (val === '发送') {
        // val为空发送消息
        message = tim.createTextMessage({
          to: groupId,
          conversationType: TIM.TYPES.CONV_GROUP,
          payload: { text: value },
        });
      } else {
        // val非空发送自定义消息
        message = tim.createCustomMessage({
          to: groupId,
          conversationType: TIM.TYPES.CONV_GROUP,
          payload: {
            data: value, // 自定义消息的数据字段
            description: '提问信息', // 自定义消息的说明字段
            extension: '?', // 自定义消息的扩展字段
          },
        });
      }

      if (isSDKReady) tim.sendMessage(message);
      pushCurrentMessageList(message);
      this.setState({ value: '', inputFocus: false }, () => {
        this.scrollToBottom();
        this.inputFocusEle.blur();
      });
    }
  }

  handleInput = (e) => {
    this.setState({ value: e.target.value });
  }

  /**
   * 解决ios软键盘空白隐藏出现空白问题
   */
  scrollPosition = () => {
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
    this.setState({ inputFocus: false });
  }

  /**
   * 直播点赞
   * @returns {Promise<void>}
   */
  changeHeart = async () => {
    const { liveInfo, flag } = this.state;
    const openId = localStorage.getItem('openId');
    try {
      const thumbsUpAni = new ThumbsUpAni();
      this.timer = setInterval(() => {
        thumbsUpAni.start();
      }, 300);
      this.setState({ isHeartShow: true });
      if (flag) {
        const { code, message } = await giveFabulous(liveInfo.id, openId);
        if (code === 20000) {
          Toast.show(message);
        }
        this.setState({ flag: false });
      }
    } catch (e) {
      // console.log(e);
    }
  }

  /**
   * 出现滚动区域时，当页面没在底部且收到新消息时 底部显示 查看最新消息按钮
   * @param scrollTop
   */
  onScroll = ({ target: { scrollTop } }) => {
    const messageListNode = this.messagesEnd;
    const { scrollHeight } = this.messagesEnd; // 里面div的实际高度

    const { clientHeight } = messageListNode; // 网页可见高度
    if (!messageListNode) {
      return;
    }
    // this.setState({ preScrollHeight: scrollHeight });
    if (scrollHeight - clientHeight - scrollTop < 20) {
      // this.setState({ isShowScrollButtomTips: false });
    }
  }

  handleInputFocus = () => {
    this.setState({ inputFocus: true }, () => {
      if (isIOS()) {
        this.inputFocusEle.focus();
      } else {
        setTimeout(() => {
          this.inputFocusEle.focus();
        }, 100);
      }
    });
  }

  goList = () => {
    this.setState({
      modeKey: 'sigUp',
    });
  }

  goProductDetail = (item) => {
    const { history } = this.props;
    const { liveId, streamName, shareUserId } = this.state;
    history.push(
      `/productDetail?productId=${item.id}&shareUserId=${shareUserId}&liveId=${liveId}&streamName=${streamName}`,
    );
  }

  // 展示更多
  moreShow = () => {
    const { moreShow } = this.state;
    this.setState({
      moreShow: !moreShow,
    });
  }

  // 展示
  liveShow = (keys) => {
    const { history } = this.props;
    const { liveInfo, shareUserId } = this.state;
    if (keys === '客服') {
      this.setState({
        visvilt2: true,
        tel: liveInfo.livePhone,
        file: false,
        visvilt2Url: '',
      });
    } else if (keys === '二维码') {
      this.setState({
        visvilt2: true,
        visvilt2Url: liveInfo.liveQrCode,
        tel: '',
        file: false,
      });
    } else if (keys === '文档') {
      this.setState({
        visvilt2: true,
        visvilt2Url: '',
        tel: '',
        file: true,
      });
    } else if (keys === '分享') {
      history.push(`/shareLive?id=${liveInfo.id}&shareUserId=${shareUserId}`);
    } else if (keys === '个人') {
      history.push(`/logistics?id=${liveInfo.id}`);
    } else if (keys === '店铺') {
      history.push(`/shop?companyCode=${liveInfo.companyCode}&shareUserId=${shareUserId}`);
    }
  }

  close2 = (value) => {
    const { visvilt2 } = this.state;
    let url = '';
    if (value !== '') {
      if (value.qrCode) {
        url = value.qrCode;
      } else {
        url = value.instructorHead;
      }
    }
    this.setState(
      {
        visvilt2: !visvilt2,
      },
      () => {
        this.setState({
          visvilt2Url: url,
          tel: '',
          file: false,
        });
      },
    );
  }

  // 获取视频的高度
  getChildValue=(value) => {
    let val = value;
    // 如果太大或太小默认240
    if (val <= 0) {
      val = 240;
    }
    this.setState({
      videoHeight: val,
    });
  }

  // 主讲人
  fixedZhuboren = () => {
    const { pools } = this.state;
    return pools.map((item) => (
      <button key={item.openId} className={styles.zTips} onClick={this.close2.bind(null, item)}>
        <img src={item.instructorHead} alt="" />
        <span>{item.instructorName}</span>
      </button>
    ));
  }

  // 查看文档
  fileList = () => {
    const { files } = this.state;
    // const { history } = this.props;
    return files.map((item) => (
      <div
        key={item.id}
        role="button"
        tabIndex={0}
        onClick={() => {
          // const type = item.url.split('.')[item.url.split('.').length - 1];
          // if (type === 'pdf') {
          //   history.push(`/filePreview?fileurl=${item.url}`);
          // } else {
          window.open(item.url);
          // }
        }}
      >
        {item.name}
      </div>
    ));
  }

  handleChangeClose = () => {
    this.setState({
      modeKey: false,
    });
  }

  renderModule = () => {
    const {
      modeKey, liveInfo, shareUserId, liveId, videoHeight,
    } = this.state;
    const { history } = this.props;
    let elementModule = null;
    if (modeKey === 'sigUp') {
      elementModule = (
        <LiveList
          videoHeight={videoHeight}
          history={history}
          liveInfo={liveInfo}
          liveId={liveId}
          shareUserId={shareUserId}
          onClose={this.handleChangeClose}
        />
      );
    }
    return elementModule;
  }

  putType = () => {
    const { put } = this.state;
    if (put === '看全部') {
      this.setState({
        put: '看提问',
      });
    } else {
      this.setState({
        put: '看全部',
      });
    }
    this.renderMessageList();
  }

  // 推荐商品
  tjSpDataList = () => {
    const { tjSpData, tjIndex } = this.state;
    return tjSpData.map((item, k) => (
      <div
        key={item.id}
        className={styles.tjList}
        style={k === tjIndex ? { border: '1px solid #FE5952' } : { border: '1px solid #ffffff' }}
        onClick={this.listTjsp.bind(null, item, k)}
        role="button"
        tabIndex={0}
      >
        <img src={item.imgUrl} alt="" />
        <div className={styles.no}>{`NO.${k + 1}`}</div>
        <div className={styles.tit}>{item.productName}</div>
      </div>
    ));
  }

  // 选择的商品
  listTjsp = (obj, k) => {
    const { tjIndex } = this.state;
    this.setState({
      tjspObj: k === tjIndex ? null : obj,
      tjIndex: k === tjIndex ? '' : k,
    });
  }

  // 点击下订
  handleToPage = (item) => {
    const { history } = this.props;
    const { liveId, streamName, shareUserId } = this.state;

    history.push(
      `/productDetail?productId=${item.id}&shareUserId=${shareUserId}&liveId=${liveId}&streamName=${streamName}`,
    );
  }

  handleGroupTip(message) {
    // 详细数据结构请参考 GroupTipPayload 接口的说明
    if (message.payload.operationType === TIM.TYPES.GRP_TIP_MBR_JOIN) {
      this.setState({ welcomeFlag: true, welcomeName: message.nick });
      setTimeout(() => {
        this.setState({ welcomeFlag: false });
      }, 6100);
    }
  }

  render() {
    const { endLive, livePerson } = this.props;
    const {
      streamName,
      liveInfo,
      inputFocus,
      value,
      isRecord,
      welcomeName,
      welcomeFlag,
      liveId,
      shareUserId,
      enterRoom,
      isHeartShow,
      fileId,
      moreShow,
      visvilt2,
      tel, // 客服电话
      visvilt2Url,
      files, // 文档
      file, // 文档查看
      tjSpData,
      lbSpData, // 列表商品
      spData, // 秒杀商品
      put, // 看全部||看提问
      tjspObj, // 选中商品
      videoHeight,
    } = this.state;
    console.log(lbSpData, spData);
    const record = Number(isRecord) === 1;
    let liveStatus;
    if (!enterRoom) {
      liveStatus = (
        <div
          className={styles.blankBox}
        />
      );
    } else {
      liveStatus = endLive ? (
        <LiveComponent
          onValue={this.getChildValue.bind(this)}
          endLive={endLive}
          appName="live"
          streamName={streamName}
          liveUrl={config.liveUrl}
          poster={liveInfo.livePicture}
          params={`?${liveInfo.plugFlowAddress && liveInfo.plugFlowAddress.split('?')[1]}`}
        />
      ) : (
        <div className={styles.blankBox}>
          <div>{!record ? '直播已结束' : '暂无录播'}</div>
        </div>
      );
    }
    return (
      <div className={styles.liveBox}>
        <Modal
          visible={visvilt2}
          transparent
          closable
          maskClosable
          onClose={this.close2.bind(null, '')}
          wrapProps={{ onTouchStart: this.onWrapTouchStart }}
        >
          {tel && (
            <div className={styles.telPhone}>
              <div>联系客服</div>
              <div>{liveInfo.livePhone}</div>
              <div>
                <div onClick={this.close2.bind(null, '')} role="button" tabIndex={0}>
                  取消
                </div>
                <div>
                  <a href={`tel:${liveInfo.livePhone}`}>拨打电话</a>
                </div>
              </div>
            </div>
          )}
          {visvilt2Url && <img src={visvilt2Url} alt="" style={{ width: 150, height: 150, marginLeft: 40 }} />}
          {file && (
            <div className={styles.textFlie}>
              <h6>选择查看的文档</h6>
              <div>{this.fileList()}</div>
            </div>
          )}
        </Modal>
        <div style={{ display: !endLive || record ? 'none' : 'block' }} className={styles.live}>
          <div className={styles.liveStatus}>
            <img style={{ width: '10px', height: '10px', marginRight: '5px' }} src={imgSignal} alt="" />
            直播中
          </div>
          <div className={styles.online}>
            在线观看
            {' '}
            {livePerson}
            人
          </div>
        </div>
        <div className={styles.zhuborens}>{this.fixedZhuboren()}</div>
        {liveStatus}
        {/* 录播 */}
        {record && !!fileId && (
        <TencentVideoPLay
          onValue={this.getChildValue.bind(this)}
          fileId={fileId}
        />
        )}

        {tjSpData.length > 0 && (
          <div className={styles.tjSpDataList}>
            <div>{this.tjSpDataList()}</div>
            {!tjspObj ? (
              <div />
            ) : (
              <div className={styles.trueList}>
                <div className={styles.trueListImg}>
                  <img src={tjspObj.imgUrl} alt="" />
                </div>
                <div className={styles.trueListCon}>
                  <div>
                    <p>{tjspObj.productName}</p>
                  </div>
                  <div>
                    ￥
                    {tjspObj.specPrice}
                    <span role="button" tabIndex={0} onClick={this.handleToPage.bind(null, tjspObj)}>
                      点击下单
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        <div
          className={styles.chatBox}
          style={{ height: `calc(99vh - ${videoHeight}px)`, top: `${videoHeight}px` }}
          onScroll={this.onScroll}
          ref={(el) => {
            this.messagesEnd = el;
          }}
        >
          <div style={{ display: welcomeFlag ? 'block' : 'none' }} className={styles.person}>
            {welcomeName}
            来了！
          </div>

          <div className={styles.messageItem}>
            <div
              className={styles.message}
              style={{ color: '#FFFFFF', display: 'flex', background: 'rgba(0,0,0,0.2)' }}
            >
              欢迎来到直播间！请大家共同遵守、监督。直播间内严禁出现非法违规、低俗色情、吸烟酗酒等内容，若违规请及时举报。
            </div>
          </div>
          {this.renderMessageList()}
        </div>
        <canvas
          className={styles.canvas}
          id="thumsCanvas"
          width="200"
          height="400"
          style={{ width: '35px', height: '60px' }}
        />
        <div className={styles.actions}>
          {record ? (
            <div style={{ opacity: 0 }} className={styles.inputImg} />
          ) : (
            <div
              style={{ display: 'flex' }}
              className={styles.inputImg}
              onTouchStart={this.handleInputFocus.bind(null)}
            >
              说点什么...
            </div>
          )}
          {record ? (
            <div style={{ opacity: 0 }} className={styles.like} />
          ) : (
            <div
              style={{ display: 'flex' }}
              className={styles.like}
              onClick={this.changeHeart}
              role="button"
              tabIndex={0}
            >
              <img src={isHeartShow ? activeHeart : heart} alt="" />
            </div>
          )}

          <div className={styles.product} onClick={this.goList} role="button" tabIndex={0}>
            <img style={{ height: '100%', width: '100%' }} src={livePro} alt="" />
            <div className={styles.productDetail}>{this.renderLiveProduct()}</div>
          </div>
          <div onClick={this.moreShow} role="button" tabIndex={0}>
            {moreShow ? (
              <img style={{ height: '30px', width: '30px' }} src={liveClose} alt="" />
            ) : (
              <img style={{ height: '35px', width: '30px' }} src={dianDianDian} alt="" />
            )}
          </div>
          {record ? (
            ''
          ) : (
            <span onClick={this.putType} role="button" tabIndex={0}>
              {put}
            </span>
          )}
        </div>
        {/** 更多 */}
        {moreShow ? (
          <div className={styles.actions2}>
            {liveInfo.livePhone && (
              <div onClick={this.liveShow.bind(null, '客服')} role="button" tabIndex={0}>
                <img src={livekefu} alt="" style={{ height: '20px', width: '20px' }} />
                <span>客服</span>
              </div>
            )}

            {liveInfo.liveQrCode && (
              <div onClick={this.liveShow.bind(null, '二维码')} role="button" tabIndex={0}>
                <img src={liveErweim} alt="" style={{ height: '20px', width: '20px' }} />
                <span>二维码</span>
              </div>
            )}
            {files.length !== 0 && (
              <div onClick={this.liveShow.bind(null, '文档')} role="button" tabIndex={0}>
                <img src={livetext} alt="" style={{ height: '20px', width: '20px' }} />
                <span>文档</span>
              </div>
            )}
            <div onClick={this.liveShow.bind(null, '分享')} role="button" tabIndex={0}>
              <img src={livefenx} alt="" style={{ height: '20px', width: '20px' }} />
              <span>分享</span>
            </div>
            <div onClick={this.liveShow.bind(null, '店铺')} role="button" tabIndex={0}>
              <img src={liveshop} alt="" style={{ height: '20px', width: '20px' }} />
              <span>店铺</span>
            </div>
            <div style={{ border: 'none' }} onClick={this.liveShow.bind(null, '个人')} role="button" tabIndex={0}>
              <img src={liveger} alt="" style={{ height: '20px', width: '20px' }} />
              <span>个人</span>
            </div>
          </div>
        ) : (
          ''
        )}

        <div className={styles.input} style={{ display: inputFocus ? 'flex' : 'none' }}>
          <input
            onBlur={this.scrollPosition.bind(null)}
            type="text"
            value={value}
            onChange={this.handleInput}
            ref={(el) => {
              this.inputFocusEle = el;
            }}
            className={styles.liveInput}
            placeholder="说点什么..."
          />
          <div
            className={styles.sendBtn}
            style={{ marginLeft: 8 }}
            onClick={this.handleMsg.bind(null, '提问')}
            role="button"
            tabIndex={0}
          >
            提问
          </div>
          <div className={styles.sendBtn} onClick={this.handleMsg.bind(null, '发送')} role="button" tabIndex={0}>
            发送
          </div>
        </div>
        {this.renderModule()}
        {enterRoom && (
          <WXShare
            title={liveInfo.liveName}
            imgUrl={liveInfo.livePicAddress}
            desc={liveInfo.liveIntroduce || '1111'}
            link={`${window.location.origin}/webapp/SignUp/?streamName=
            ${streamName}&isRecord=${isRecord}&liveId=${liveId}&staffUserId=${shareUserId}`}
          />
        )}
      </div>
    );
  }
}

LiveRegistration.propTypes = propTypes;
LiveRegistration.defaultProps = defaultProps;

export default LiveRegistration;
